<template>
  <div class="map">
    <div id="container"></div>
    <div class="background"></div>
    <div class="menus">
      <el-button v-if="buttonState" size="mini" type="default" class="button" @click="back()">返回</el-button>
      <el-button v-if="buttonState" size="mini" type="default" class="button" @click="reduce()">缩小</el-button>
      <el-button v-if="buttonState" size="mini" type="default" class="button" @click="amplify()">放大</el-button>
    </div>
  </div>
</template>

<script>
  import AMapLoader from '@amap/amap-jsapi-loader';
import { time } from 'echarts';

  export default {
    name: "map",
    data() {
      return {
        map: null,
        wzxxTimer: null,
        gjxxTimer: null,
        // 标记点的数据
        dkryList: [],
        dkryMarkerPointList: [],
        gjxxList: [],
        buttonState: false,
        gjMarker: null,
        drawPolyline: null,
        passedPolyline: null
      }
    },
    created() {
      this.getDkwzxx()
      this.getLocation()
    },
    mounted() {
      this.initAMap()
      this.setInterval()
    },
    beforeDestroy() {
      clearInterval(this.wzxxTimer)
      clearInterval(this.gjxxTimer)
    },
    methods: {
      getDkwzxx(num) {
        this.$request({
          url: '/bjba/dp/getDkwzxx',
          method: 'get',
          params: {  }
        })
        .then(response => {
          console.log("获取到的打卡位置信息为：",response)
          if(response.status == 200 && response.data) {
            this.dkryList = response.data
            if (num == 1) {
              // 定时获取点数据，更新前需先清掉原来的标记点
              if (this.dkryMarkerPointList.length !== 0) {
                this.map.remove(this.dkryMarkerPointList)
                this.dkryMarkerPointList = []
              }
              this.setMarker()
            } 
          } 
        })
        .catch(error => {
            console.log(error)
        })
      },
      getLocation() {
        this.$request({
          url: '/bjba/dp/getLocation',
          method: 'get',
          params: {  }
        })
        .then(response => {
            console.log("返回轨迹数据为：",response)
            this.gjxxList = response.data
        })
        .catch(error => {
            console.log(error)
        })
      },
      initAMap() {
        console.log("初始化地图")
        AMapLoader.reset()
        AMapLoader.load({
          "key": "4a1bb32a7f10e6e6fd440f579009939f", //申请好的Web端开发者Key，首次调用load时必填
          "version": "2.0",  //指定要加载的JSAPI的版本，缺省时默认为1.4.15
          "plugins": ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
          // "Loca":{  //是否加载 Loca,缺省不加载
          //     "version": '2.0.0'  //Loca 版本,缺省1.3.2
          // }
        })
          .then((AMap) => {
            // 创建地图
            this.map = new AMap.Map('container', {
              viewMode: '3D',
              zoom: 12,
              zooms: [2, 22],
              center: [121.460425, 31.406121],
              mapStyle: 'amap://styles/blue'
            })
            if (this.dkryList.length == 0) {
              this.getDkwzxx(1)
            } else {
              this.setMarker()
            }
          })
          .catch((e) => {
            console.log(e)
          })
      },
      setMarker() {
        // 在岗人员--绘制标记点
        this.dkryList.forEach(value => {
          if (value.longitude !== null && value.latitude !== null) {
            var markerPoint = new AMap.Marker({
              position: [value.longitude, value.latitude], 
              extData: value
            })
            // 创建标记点的div
            var markerDiv = document.createElement('div')
            // 设置标记点className,用于设置点的样式（动画）
            markerDiv.className = 'alarmDeviceDkry'
            // 将标记点div，设置为标记点内容
            markerPoint.setContent(markerDiv)
            // // 标记点的list，清空点时用
            this.dkryMarkerPointList.push(markerPoint)
            // 将标记点绘制到地图
            this.map.add(markerPoint)

            // 定义提示框标记信息
            var markerText = null;
            markerPoint.on('mouseover', (e) => {
              markerText = new AMap.Marker({
                position: [e.lnglat.lng,e.lnglat.lat], 
              })
              var str = '<div class="amap-info-window">';
              str = str + '<div class="div-text">' + markerPoint.getExtData().username + '</div><div class="div-text-dkcg">打卡成功！</div></div>'
              markerText.setContent(
                str
                // '<div class="amap-info-window"><div class="div-text">' + markerPoint.getExtData().zydm 
                //   + '</div><div class="div-text">' + markerPoint.getExtData().username  
                //   + '</div><div class="div-text-dkcg">打卡成功！</div></div>',
              );
              this.map.add(markerText);
            });
            markerPoint.on('mouseout', (e) => {
              if (markerText) {
                this.map.remove(markerText);
              }
            });
            markerPoint.on('click', (e) => {
              var userid = markerPoint.getExtData().userid;
              var dataLineArr = [];
              this.gjxxList.forEach(item => {
                if (item[userid]) {
                  dataLineArr = item[userid];
                }
              });
              console.log("巡逻轨迹的数据为：",dataLineArr)
              if (dataLineArr.length < 2) {
                this.$message({
                  message: `暂无巡逻轨迹`,
                  type: 'error'
                });
              } else {
                this.setGjxx(dataLineArr)
              }
            });
          }
        })
      },
      setGjxx(dataLineArr) {
        clearInterval(this.wzxxTimer)
        var map = this.map;
        var that = this;
        // JSAPI2.0 使用覆盖物动画必须先加载动画插件
        AMap.plugin('AMap.MoveAnimation', function(){
            map.clearMap() 
            map.setCenter(dataLineArr[0]) 
            map.setZoom(26)  
            map.setZooms([20,26])

            // 创建点标记
            that.gjMarker = new AMap.Marker({
                map: map,
                position: dataLineArr[0],
                icon: "data:image/png;base64,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",
                offset: new AMap.Pixel(-13, -26),
            });

            // 绘制轨迹线条
            that.drawPolyline = new AMap.Polyline({
                map: map,
                path: dataLineArr,
                showDir:true,
                strokeWeight: 6, 
                strokeColor: "#28F", 
            });

            // 运动轨迹线条 
            that.passedPolyline = new AMap.Polyline({
                map: map,
                strokeColor: "#AF5",  
                strokeWeight: 6,  
            });

            that.gjMarker.on('moving', function (e) {
                // 给运动轨迹设置路线
                that.passedPolyline.setPath(e.passedPath);
                // 设置地图的中心点
                map.setCenter(e.target.getPosition(),true)
            });

            map.setFitView();

            // 开启动画
            that.gjMarker.moveAlong(dataLineArr, {
                duration: 500,
                autoRotation: true,
                circlable: true,
                aniInterval: 1000,
                delay: 1000
            });

            that.$emit("clickData","标记点")
            that.buttonState = true
        });
      },
      setInterval() {
        this.wzxxTimer = setInterval(() => {
          this.getDkwzxx(1)
        }, 30000);
        this.gjxxTimer = setInterval(() => {
          this.getLocation()
        }, 60000);
      },
      // 返回按钮
      back() {
        this.gjMarker.stopMove() 
        // 绘制的折线删除
        if (this.drawPolyline) {
          this.drawPolyline.setMap(null);
          this.drawPolyline = null;
        }
        // 走过的折线删除
        if (this.passedPolyline) {
          this.passedPolyline.setMap(null);
          this.passedPolyline = null;
        }
        // 轨迹图删除
        if (this.gjMarker) {
          this.map.remove(this.gjMarker)
        }
        this.map.clearMap() 
        this.map.setCenter([121.460425, 31.406121])
        this.map.setZoom(12) 
        this.map.setZooms([2, 22])
        this.getDkwzxx(1);
        this.setInterval()
        this.$emit("clickData","返回")
        this.buttonState = false
      },
      // 放大按钮
      amplify() {
        this.map.zoomIn() 
      },
      // 缩小按钮
      reduce() {
        var zooms = this.map.getZooms()
        if (zooms[0] > 2) {
          var num = zooms[0] - 1
          this.map.setZooms([num, zooms[1]])
        }
        this.map.zoomOut()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .map {
    width: 100%;
    height: 720px;
    position: relative;
  }
  #container {
    width: 100%;
    height: 100%;
    border-radius: 32px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .background {
    width: 100%;
    height: 100%;
    border-radius: 32px;
    background-color: rgba(0, 23, 88, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    pointer-events:none;
  }
  .menus {
    // width: 90%;
    // height: 39px;
    position: absolute;
    top: 50px;
    right: 100px;
  }
  .menus .button {
    float: right;
    background-color: #0fe6db;
    border: #0fe6db;
    color: #ffffff;
    font-weight: bolder;
    margin-left: 20px;
  }
</style>  

<style>
  /* 隐藏左下角高德地图logo */
  .amap-logo, .amap-copyright {
    display: none !important;
  }
  
  .alarmDeviceDkry{
    text-align:center;
    margin: 0 auto;
    width: 26px;
    height: 26px;
		background-color: rgba(0,255,0,0.3);
    border-radius: 50%;
    box-shadow: 0px 0px 2px 2px rgb(0,255,0);
    -webkit-animation-name: 'alarmDeviceBreathDkry';/*动画属性名，也就是我们前面keyframes定义的动画名*/
    -webkit-animation-duration: 1s;/*动画持续时间*/
    -webkit-animation-timing-function: ease; /*动画频率，和transition-timing-function是一样的*/
    -webkit-animation-delay: 0s;/*动画延迟时间*/
    -webkit-animation-iteration-count: infinite;/*定义循环资料，infinite为无限次*/
    -webkit-animation-direction: alternate;/*定义动画方式*/
  }

  .alarmDeviceDkry::before {
    background-color: rgb(0,255,0);
    height: 60%;
    width: 60%;
    border-radius: 50%;
    display: block;
    content: '';
    position: relative;
    top: 20%;
    left: 20%;
  }

  @keyframes alarmDeviceBreathDkry{
    0% {margin-left: 0;margin-top: 0;width:15px;height:15px;opacity: 1.2;}
		100% {margin-left: 5px;margin-top: 5px;width:10px;height:10px;opacity: 0.6;}
  }

  /* 提示框信息 */
  .amap-info-window{
    width: 100px;
    background-image: url('../image/dkcgbj.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 3px;
    padding: 10px;
    position: relative;
    text-align: center;
  }

  .div-text {
    margin: 0px;
    font-size: 13px;
    font-weight: bolder;
    color:#ffffff;
  }

  .div-text-dkcg {
    margin: 0px;
    padding-left: 15px;
    font-size: 15px;
    color: #1a2e57;
  }
</style>